import React from 'react'
import { LangSteps51 } from '../../../constant/languange'
import Content from '../Content'

const Fifth1 = (props) => {
  const data = {
    title: '',
    steps: [LangSteps51],
    button: 'Mulai Atur Lokasi Kehadiran',
    nextStep: 6,
    skipTo: '/company/setting',
    isDone: props.stats.spots_count
  }

  return <Content {...props} data={data} />
}

export default Fifth1
